import { render, staticRenderFns } from "./newDesc3.vue?vue&type=template&id=6aa1bd90&scoped=true"
import script from "./newDesc3.vue?vue&type=script&lang=js"
export * from "./newDesc3.vue?vue&type=script&lang=js"
import style0 from "./newDesc3.vue?vue&type=style&index=0&id=6aa1bd90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa1bd90",
  null
  
)

export default component.exports